<template>
  <section>
    <EventsIndexHeader />
    <EventsIndexSearch />
    <EventsIndexIndex />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'EventsIndex',
  components: { ...partials }
}
</script>
